import React from "react";
import PropTypes from "prop-types";
import classes from "./Row.module.scss";
import cl from "classnames";
const Row = ({ visible = true, children }) => (
  <div className={cl([classes.row, { [classes.hidden]: !visible }])}>
    {children}
  </div>
);

export default Row;
